import React, { Component } from 'react';
import { List } from 'semantic-ui-react'
import { Dropdown } from 'semantic-ui-react'
import '../App.css';
import 'semantic-ui-css/semantic.min.css';
import { createControl, updateControl, deleteControl, createControlFailure, updateControlFailure, deleteControlFailure } from '../actions/control'
import { updateTags } from '../actions/tags'
import { connect } from 'react-redux';
const ReactMarkdown = require('react-markdown')

class ControlsRenderer extends Component {
  constructor(props){
    super(props);
    this.state = {
      controls: this.formatControls(this.props.value),
      riskId: this.props.riskId,
      controlIndex: 0,
      tagOptions: [
        {
          key: 'Tag1',
          value: 'Tag1',
          text: 'Tag1'
        },
        {
          key: 'Tag2',
          value: 'Tag2',
          text: 'Tag2'
        },
        {
          key: 'Tag3',
          value: 'Tag3',
          text: 'Tag3'
        },
        {
          key: 'Tag4',
          value: 'Tag4',
          text: 'Tag4'
        },
        {
          key: 'Tag5',
          value: 'Tag5',
          text: 'Tag5'
        },
      ],
      newTag: '',
      dropdownVariables: {}
    }

    if (!this.props.isRiskHidden){
      for (var i in this.state.controls){
        this.extractTags(this.state.controls[i]);
      }
    }
  }

  componentDidMount(){
    this.addhandlers();
  }

  componentDidUpdate(){
    this.addhandlers();
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.actionRiskId === this.state.riskId){
      if (nextProps.createSuccess){
        var found = this.state.controls.some((el) => {
          return el.id === nextProps.control.id;
        });
        if (!found) {
          var controls = this.state.controls.splice(this.state.controlIndex, 0, nextProps.control);
          this.setState({
            conrols: controls
          })
        }
        this.props.resetCreateControl();
      }
      else if (nextProps.updateSuccess) {
        this.props.resetUpdateControl();
      }
      else if (nextProps.deleteSuccess) {
        this.props.resetDeleteControl();
      }
    }
  }

  addhandlers(){
    for (var i in this.state.controls){
      var element = document.getElementById(this.state.controls[i].id.toString())
      element.setAttribute('tabindex',this.state.controls[i].id.toString())
      element.addEventListener('input', (evt) => this.handleChange(evt));
    }
  }

  formatControls(controls){
    var new_controls = []
    if (controls){
      new_controls = JSON.parse(controls)
    }
    return new_controls
  }

  controlRenderer(control) {
    var new_control = ""
    if (control){
     new_control = control.replace(/(#[a-zA-Z]*)/g, "[$1](/ '$1')")
    }
    return (
     <ReactMarkdown source={new_control}/>
    );
  }

  removeTags(name){
    return name.replace(/(#[a-zA-Z]*)/g, "")
  }

  getTags(name){
    var tags = name.match(/(#[a-zA-Z]*)/g)
    //returns the unique tags
    return [...new Set(tags)]
  }

  extractTags(control){
    for (var i in control.tag_list){
      var tag = {
        key: control.tag_list[i],
        value: control.tag_list[i],
        text: control.tag_list[i]
      }
      this.props.setTagOptions(tag)
    }
  }

  setAsEditable(evt){
    evt.target.setAttribute("contentEditable","true");
  }

  handleItemFocus(evt, index){
    evt.target.setAttribute("contentEditable","true");
    this.setState({
      controlIndex: index
    })
  }

  handleItemOnBlur(evt, index, object){
    evt.target.setAttribute("contentEditable","false");
    var controls = this.state.controls.slice();
    var control = controls[index];
    control.name = evt.target.innerText.replace(/\n/g,"");
    this.setState({
      controls: controls
    });
    this.props.updateControl(this.props.planId, this.props.riskId, control);
  }

  handleChange(evt){
  }

  controlsKeyUp(evt, object){
    var keycode = (evt.keyCode ? evt.keyCode : evt.which);
    if(keycode == '13' && evt.altKey){
      object.addControl(object.state.controlIndex + 1)
    }
  }

  addControl(index){
    this.setState({
      controlIndex: index
    })
    this.props.createControl(this.props.planId, this.props.riskId);
  }

  deleteControl(index){
    var control = this.state.controls[index];
    this.props.deleteControl(this.props.planId, this.props.riskId, control)
    var controls = this.state.controls.splice(index, 1);
    this.setState({
      conrols: controls
    })
  }

  updateTags(evt, data, control_id){
    for (var i in data.value){
      var tag = {
        key: data.value[i],
        value: data.value[i],
        text: data.value[i]
      }
      this.props.setTagOptions(tag)
    }
    this.props.updateTags(this.props.planId, this.props.riskId, control_id, data.value.join(', '));
  }

  tagsKeyUp(evt, object){
    if (evt.target.value !== ''){
      object.setState({
        newTag: {
          key: evt.target.value,
          value: evt.target.value,
          text: evt.target.value,
        }
      })
    }

    var keycode = (evt.keyCode ? evt.keyCode : evt.which);
    if(keycode == '13'){
      var options = object.addNewTagOption(object.state.newTag)
      this.setState({
        tagOptions: options
      })
    }
  }

  tagExists(newTag){
    var exists = false;
    for (var i in this.state.tagOptions){
      if (this.state.tagOptions[i].key === newTag.key){
        exists = true;
        break;
      }
      else {
        exists = false
      }
    }
    return exists
  }

  addNewTagOption(newTag){
    if (this.state.tagOptions.length===0){
      this.state.tagOptions.splice(0, 0, newTag);
      this.props.setTagOptions(newTag)
    }
    else {
      for (var i in this.state.tagOptions){
        if (this.state.tagOptions[i].key === newTag.key){
          break;
        }
        if (parseInt(i, 10) === this.state.tagOptions.length -1){
          this.state.tagOptions.splice(0, 0, newTag);
          this.props.setTagOptions(newTag)
        }
      }
    }
    return this.state.tagOptions
  }

  toggleDropdown(id){
    var el = document.getElementById('drop'+id)
    if (el.style.display === 'block'){
      el.style.display = 'none';
    }
    else {
      el.style.display = 'block';
    }
  }

  listItemRenderer(control, index){
    var style = { display: 'block' }
    if (control.tag_list.length === 0){
      style = { display: 'none' }
    }
    return (
      <div className="controls-renderer">
        <div id={control.id}
          className="control-input"
          title={control.name}
          onFocus={(evt) => this.handleItemFocus(evt, index)}
          onBlur={(evt)=>this.handleItemOnBlur(evt, index, this)}
          onKeyUp={(evt)=>this.controlsKeyUp(evt, this)}>
          {this.removeTags(control.name)}
          <i className="tag icon"
            onClick={()=>this.toggleDropdown(control.id)}
            contentEditable="false"
            title="Show or hide tags for this control.">
          </i>
        </div>
        <i className="delete icon delete-control"
          onClick={()=>this.deleteControl(index)}
          contentEditable="false"
          title="Delete this control.">
        </i>
        <Dropdown
          id={"drop" + control.id}
          ref={"drop" + control.id}
          style={style}
          className="control-dropdown"
          placeholder='Add a tag'
          fluid
          multiple
          search
          selection
          options={this.state.tagOptions}
          defaultValue={control.tag_list}
          onChange={(evt, data)=>this.updateTags(evt, data, control.id)}
          closeOnBlur={true}>
        </Dropdown>
      </div>
    )
  }

  render() {
    const { controls } = this.state
    const controlItems = controls.map((control, index) => {
      return (
        <List.Item key={control.id} content={this.listItemRenderer(control, index)}>
        </List.Item>
      )
    })
    return (
      <div className="controls-list">
        <a className="add-control" onClick={() => this.addControl(0)}><i className="plus icon"></i>New Control</a>
        <List bulleted>
          { controlItems }
        </List>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    control: state.control.control,
    pending: state.control.pending,
    createSuccess: state.control.createSuccess,
    updateSuccess: state.control.updateSuccess,
    deleteSuccess: state.control.deleteSuccess,
    actionRiskId: state.control.riskId,
    updateTagsSuccess: state.tags.updateSuccess,
    tags: state.tags.tagList
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createControl: (plan_id, risk_id) => {
      dispatch(createControl(plan_id, risk_id))
    },
    updateControl: (plan_id, risk_id, control) => {
      dispatch(updateControl(plan_id, risk_id, control))
    },
    deleteControl: (plan_id, risk_id, control) => {
      dispatch(deleteControl(plan_id, risk_id, control))
    },
    updateTags: (plan_id, risk_id, control_id, tag_list) => {
      dispatch(updateTags(plan_id, risk_id, control_id, tag_list))
    },
    resetCreateControl: () => {
      dispatch(createControlFailure());
    },
    resetUpdateControl: () => {
      dispatch(updateControlFailure());
    },
    resetDeleteControl: () => {
      dispatch(deleteControlFailure());
    },
  }
}

let ControlsRendererView = connect(mapStateToProps, mapDispatchToProps)(ControlsRenderer)
export default ControlsRendererView;



// WEBPACK FOOTER //
// ./src/components/custom_controls_renderer.js